import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class LobByOid
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: LobByOid.Params): Observable<Tlob>
	{
		return this.m_queryInvoker.doQuery("LobByOid", params);
	}
	getLobUrl(params: LobByOid.Params): string
	{
		return this.m_queryInvoker.buildLobUrl("LobByOid", params);
	}
};

export namespace LobByOid
{
	export class Params
	{
		lob: string;
	};
};
